export default __webpack_public_path__ + "static/media/illegal-logging.bed8c9d1.svg";